// pass generic type to extend base interface
export type BaseTimeSeriesData<T = {}> = T & {
    id: string;
    timestamp: number;
    instrumentId: number;
};

export interface LegacyMarketData {
    instrumentId: number;
    price: number;
    shares?: number;
    diluted?: number;
    totalArea?: number;
    totalEconomicArea?: number;
    occupiedArea?: number;
    date: string;
    currency?: string;
    priceValidationLevel?: string;
}

export const generateTimeSeriesDataId = (instrumentId: number, date: Date) => {
    return `MV_${instrumentId}_${date?.toISOString().slice(0, 10)}`;
};
